import React, { useEffect, useState } from "react";

import { AnimatedContainerWrapper, AnimatedChild } from "./styles";

interface AnimatedContainerProps {
  children: React.ReactNode;
}

function AnimatedContainer({ children }: AnimatedContainerProps) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <AnimatedContainerWrapper isVisible={isVisible}>
      {React.Children.map(children, (child, index) => (
        <AnimatedChild key={index} delay={(index + 1.4) * 0.5 + "s"}>
          {child}
        </AnimatedChild>
      ))}
    </AnimatedContainerWrapper>
  );
}

export default AnimatedContainer;
